// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { FamilyStatus } from './family-status';
import { GroupFamily } from './group-family';
import { Household } from './household';
import { Person } from './person';
import { Photo } from './photo';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Family extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Statuses = {
        Visitor: 5,
        ProfessingMember: 6,
        Deceased: 7,
        InActiveMember: 61,
        RegularAttender: 62,
        NonMember: 223,
        NonFamily: 224,
        Baptised: 227,
        ProgramParent: 277,
        ProgramAttender: 280,
        Family: 293,
        ProgramGrandparent: 321,
        ProgramGuardian: 378,
        Transferred: 63,
        Lapsed: 268,
        Resigned: 677,
    };

    get displayAddress() {
        const address = `${this.address1 || ''} ${this.address2 || ''} ${this.city || ''} ${this.state || ''} ${this.zip || ''}`;
        return address;
    }

    updateName() {
        if (!this.members) return;

        let name = 'Blank Family';

        if (this.members.length > 0) {
            const head = _(this.members).find((m: Person) => !!m.relationship && m.relationship.name === 'Head of Household');
            const spouse = _(this.members).find((m: Person) => !!m.relationship && m.relationship.name === 'Spouse');
            name =
                head?.deceasedDate && (!spouse || (spouse && spouse?.deceasedDate))
                    ? `${head.lastName}, ${head.firstName}`
                    : head && !head.deceasedDate
                    ? `${head.lastName}, ${head.firstName} ${
                          spouse && !spouse.deceasedDate ? `& ${spouse.firstName}${spouse.lastName !== head.lastName ? ' ' + spouse.lastName : ''}` : ''
                      }`
                    : spouse && !spouse.deceasedDate
                    ? `${spouse.lastName}, ${spouse.firstName}`
                    : 'New Family';
        }

        if (this.name !== name) this.name = name;
    }
    get headOfHousehold() {
        const head = _(this.members).find((m: Person) => !!m.relationship && m.relationship.name === 'Head of Household');
        return head;
    }

    phone: string;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  address1?: string;
  address2?: string;
  city?: string;
  country?: string;
  created!: Date;
  createdBy?: string;
  emergencyContact?: string;
  emergencyPhone?: string;
  familyStatusId?: number;
  homePhone?: string;
  householdId?: number;
  includeInDirectory!: boolean;
  isActive!: boolean;
  isHomePhoneUnlisted!: boolean;
  name?: string;
  note?: string;
  oldFamilyId?: string;
  state?: string;
  updated!: Date;
  updatedBy?: string;
  zip?: string;
  familyStatus!: FamilyStatus;
  groupFamilies!: GroupFamily[];
  household!: Household;
  members!: Person[];
  photos!: Photo[];
}

